import { Navigate } from 'react-router-dom'
import { AppNoTenantLanding } from '@/pages/AppNoTenantLanding/AppNoTenantLanding'
import {
  getBuildTimeTenantSlug,
  getTenantEntryPath,
  isNativeWhiteLabelBuild,
} from '@/config/tenant'

/**
 * Raiz (/): landing comercial no browser.
 * Só apps nativas white-label (VITE_TENANT_SLUG no build) vão para /e/slug.
 * Não redirecionar por localStorage — visitar /e/empresa não deve “raptar” gobooking.pt/.
 */
export function ClientPublicRoot() {
  const buildSlug = getBuildTimeTenantSlug()
  if (buildSlug) {
    return <Navigate to={getTenantEntryPath(buildSlug)} replace />
  }

  if (isNativeWhiteLabelBuild()) {
    return (
      <main style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
        <h1>App não configurada</h1>
        <p>Esta instalação não tem empresa associada. Gere o pacote novamente no painel Platform.</p>
      </main>
    )
  }

  return <AppNoTenantLanding />
}
